import templateBase from './templates/category-pager-toolbox-base.view.html';
import template_t1 from './templates/category-pager-toolbox-t1.view.html';
import template_t11 from './templates/category-pager-toolbox-t11.view.html';
import template_t15 from './templates/category-pager-toolbox-t15.view.html';

function MenuDirective(SessionService) {

  let response = SessionService.get('components');
  let htmlTemplate = templateBase;

  if (response.CATEGORY_PAGER_TOOLBOX.component == 'template_t1') { htmlTemplate = template_t1; }
  else if (response.CATEGORY_PAGER_TOOLBOX.component == 'template_t11') { htmlTemplate = template_t11; }
  else if (response.CATEGORY_PAGER_TOOLBOX.component == 'template_t15') { htmlTemplate = template_t15; }
  return {
    restrict: 'E',
    template: htmlTemplate,
  };
}

MenuDirective.$inject = ['SessionService'];

export default MenuDirective;


// WEBPACK FOOTER //
// ./www/components/catalog/category/category-pager-toolbox/category-pager-toolbox.directive.js